module.exports = __webpack_public_path__ + "static/img/4@2x.86965cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/productCase/4@2x.png
// module id = JlUh
// module chunks = 0